import React from 'react';
import { useNavigate } from 'react-router-dom';
import Row from '../../../Common/Row';
import Col from '../../../Common/Col';
import Input from '../../../Common/HtmlTags/Input';
import Button from '../../../Common/HtmlTags/Button';
import LoadingIndicator from '../../../store/LoadingIndicator';
import { GoBack } from '../../../../containers/goBack/inedx';
import AdvancedUpload from '../../../store/AdanceFileUpload';
import Switch from '../../../store/Switch';
import { connect } from 'react-redux';
import { withRouter } from '../../../../withRouter';
import actions from '../../../../actions';

const AddPartnerLogoForm = (props) => {
  const {
    partnerLogoFormData,
    formErrors,
    partnerLogoChange,
    addPartnerLogo,
    isLoading,
    isLightMode,
  } = props;

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    addPartnerLogo(navigate);
  };

  return (
    <div className='add-event d-flex flex-column mb-custom-5em'>
      {isLoading && <LoadingIndicator isLightMode={isLightMode} />}
      <div
        style={{
          marginBottom: '-1em',
          justifyContent: 'space-between',
          padding: '0em 1em',
        }}
        className='d-flex team-members-header'
      >
        <h2 className={`${isLightMode ? 'p-black' : 'p-white'} font-size-25`}>Add Partner Logo</h2>
        <GoBack navigate={navigate} />
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <Row>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12' lg='6'>
            <Input
              type='text'
              error={formErrors.name}
              label='Name'
              name='name'
              placeholder='Enter partner name'
              value={partnerLogoFormData.name}
              onInputChange={partnerLogoChange}
            />
          </Col>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12' lg='6'>
            <label className='me-2'>Show on site</label>
            <Switch
              id='partner-logo-enabled-add'
              checked={partnerLogoFormData.isEnabled !== false}
              toggleCheckboxChange={(value) => partnerLogoChange('isEnabled', value)}
            />
          </Col>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12'>
            <h5>Upload Logo</h5>
            <AdvancedUpload
              error={formErrors.image}
              onFilesChange={(files) => partnerLogoChange('image', files)}
              imageLimit={10 * 1024 * 1024}
              videoLimit={0}
              limit={1}
              vLimit={0}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '1em' }}>
          <div className='add-event-actions'>
            <Button style={{ padding: '10px 20px' }} text='Save Partner Logo' />
          </div>
        </Row>
      </form>
    </div>
  );
};

class AddPartnerLogo extends React.PureComponent {
  componentDidMount() {
    this.props.resetPartnerLogo();
  }

  render() {
    return <AddPartnerLogoForm {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  partnerLogoFormData: state.partnerLogos.partnerLogoFormData,
  formErrors: state.partnerLogos.formErrors,
  isLightMode: state.dashboard.isLightMode,
  isLoading: state.partnerLogos.isLoading,
});

export default connect(mapStateToProps, actions)(withRouter(AddPartnerLogo));
